// FROM: https://mortgage.archgroup.com/us-credit-union/rate-sheets/
// Use: Monthly/Annual/Split – Borrower/Lender Paid Rates
// Nationwide Monthly Premium Rates (Except AK, GA, HI, KS, LA, MO, NE, NM, NY, OH, PA, RI, SD, TX, VA, & WA)
// Rates Are Annualized so we need to divide them by 12 to get a monthly rate

export const pmiTable = {
  [740]: [
    { pmiRate: 0.16, maxLTV: 0.85 },
    { pmiRate: 0.21, maxLTV: 0.9 },
    { pmiRate: 0.3, maxLTV: 0.95 },
    { pmiRate: 0.41, maxLTV: 0.97 }
  ],
  [700]: [
    { pmiRate: 0.18, maxLTV: 0.85 },
    { pmiRate: 0.27, maxLTV: 0.9 },
    { pmiRate: 0.4, maxLTV: 0.95 },
    { pmiRate: 0.53, maxLTV: 0.97 }
  ],
  [660]: [
    { pmiRate: 0.21, maxLTV: 0.85 },
    { pmiRate: 0.45, maxLTV: 0.9 },
    { pmiRate: 0.67, maxLTV: 0.95 },
    { pmiRate: 0.91, maxLTV: 0.97 }
  ],
  [620]: [
    { pmiRate: 0.35, maxLTV: 0.85 },
    { pmiRate: 0.54, maxLTV: 0.9 },
    { pmiRate: 0.9, maxLTV: 0.95 },
    { pmiRate: 1.08, maxLTV: 0.97 }
  ],
  [580]: [
    { pmiRate: 0.49, maxLTV: 0.85 },
    { pmiRate: 0.76, maxLTV: 0.9 },
    { pmiRate: 1.26, maxLTV: 0.95 },
    { pmiRate: 1.51, maxLTV: 0.97 }
  ],
  [579]: [
    { pmiRate: 0.49, maxLTV: 0.85 },
    { pmiRate: 0.76, maxLTV: 0.9 },
    { pmiRate: 1.26, maxLTV: 0.95 },
    { pmiRate: 1.51, maxLTV: 0.97 }
  ]
};
